import React from 'react';
import styled from 'styled-components';

// @ts-ignore
import { ReactComponent as Car } from 'src/assets/qiche.svg';
import { ReactComponent as WalkMan } from 'src/assets/walk-man.svg';
import { VEHICLE_ONLY } from 'src/config';

import { useMonitor } from './monitor.provider';

type WarningDrawerTriggerProps = {
  onClick?: () => void;
};

export const WarningDrawerTrigger: React.FC<WarningDrawerTriggerProps> = (props) => {
  const [{ settings }] = useMonitor();

  return (
    <Container>
      <WatchStatisticsBar onClick={props.onClick}>
        <WatchStatistics>
          布控中卡口：
          <Car style={{ width: 23, height: 23, fill: '#fff', marginRight: '3px' }} />
          {settings.motor.gantries.length + Object.keys(settings.motor.gantryMap).length}
        </WatchStatistics>
        {!VEHICLE_ONLY && (
          <WatchStatistics className="stats-non-motor">
            <WalkMan style={{ width: 23, height: 23, fill: '#fff', marginRight: '3px' }} />
            {settings.nonMotor.gantries.length + Object.keys(settings.nonMotor.gantryMap).length}
          </WatchStatistics>
        )}
      </WatchStatisticsBar>
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  z-index: 900;
  display: inline-flex;
  align-items: center;
`;
const WatchStatisticsBar = styled.button`
  width: 270px;
  height: 48px;
  background-color: #ef7d22;
  color: #fff;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-weight: 400;
  padding-left: 16px;
  padding-right: 16px;
  cursor: pointer;

  .stats-non-motor {
    margin-left: 8px;
  }
`;
const WatchStatistics = styled.div`
  display: inline-flex;
  align-items: center;
  opacity: '0.65';
`;
